export const NO_ACCOUNT_DATA_HEADER = "You don't have any data yet";

export const NO_ACCOUNT_DATA_SUB_HEADER =
  'Please get in touch so we can set up your account.';
